module.exports = __webpack_public_path__ + "static/media/something-went-wrong-mobile.afdd6356.png";